import axios from "axios";
import React from "react";
import { Dropdown } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import logo from "../../../assets/images/helloSuperStar.png";
import noImage from "../../../assets/images/settings/no-image.png";
import TopInfo from "../../../Layouts/TopInfo";

const Navbar = () => {
  const history = useHistory();

  const sidebarToggle = () => {
    document.body.classList.toggle("sb-sidenav-toggled");
    localStorage.setItem(
      "sb|sidebar-toggle",
      document.body.classList.contains("sb-sidenav-toggled")
    );
  };

  const logoutSubmit = (e) => {
    e.preventDefault();

    axios.post(`/api/logout`).then((res) => {
      if (res.data.status === 200) {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("auth_name");
        localStorage.removeItem("auth_otp");
        localStorage.removeItem("auth_id");
        localStorage.removeItem("auth_phone");
        localStorage.removeItem("auth_type");

        // swal("Success", res.data.message, "success");
        history.push("/");
        //browserHistory.push("/path-to-link");
        //window.location.href = "/";
      } else {
        swal("Warning", res.data.message, "Warning");
        //history.push('/');
      }
    });
  };

  return (
    <nav className="sb-topnav navbar navbar-expand navbar-dark bg-dark">
      <div className="d-flex justify-content-between align-items-center desk-tab-x ">
        <div>
          <Link className="Link" to="/jury-board">
            <img
              src={logo}
              alt=""
              className="logo-ad-logo px-2"
              style={{ width: "40px" }}
            />
            <span className="navbar-brand LogoName">Jury Board</span>
          </Link>
        </div>
        <div>
          <button
            className="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0 text-white"
            id=""
            onClick={sidebarToggle}
          >
            <i className="fas fa-bars"></i>
          </button>
        </div>
      </div>

      <form className="d-md-inline-block form-inline ms-auto me-0 me-md-3 my-2 my-md-0">
        <div className="input-group">
          <input
            className="form-control SearchS "
            type="search"
            placeholder="Search for..."
            aria-label="Search for..."
            aria-describedby="btnNavbarSearch"
          />
          <button
            className="btn btn-warning btnS "
            id="btnNavbarSearch"
            type="button"
          >
            <i className="fas fa-search"></i>
          </button>
        </div>
      </form>
      <TopInfo
        profile={"/jury-board/profile"}
        settings={"/jury-board/profile-settings"}
      />
    </nav>
  );
};

export default Navbar;
